import api from '../services/api';

export const updateAvailableCredit = async (clientData, setClientData) => {
  try {
    const response = await api.get(`/customers/${clientData.id}/credit-info`);
    
    if (response.data.status === 'COMPLETED') {
      setClientData(prevData => ({
        ...prevData,
        total_limit: response.data.limits.total_limit,
        available_credit: response.data.limits.available_limit,
        status: 'COMPLETED'
      }));
    } else if (response.data.status === 'REJECTED') {
      setClientData(prevData => ({
        ...prevData,
        total_limit: 0,
        available_credit: 0,
        status: 'REJECTED',
        message: response.data.message
      }));
    }
  } catch (error) {
    if (error.response?.status === 403) {
      setClientData(prevData => ({
        ...prevData,
        total_limit: 0,
        available_credit: 0,
        status: 'REJECTED',
        message: error.response.data.message || 'No hay crédito disponible.'
      }));
    }
    console.error('Error al actualizar límite de crédito:', error);
  }
}; 